export const locale = {
    lang: 'pl',
    data: {
        "Name": "Nazwa",
        "Phone": "Telefon",
        "Supplier": "Dostawca",
        "Add supplier": "Dodaj dostawcę",
        "Invoice number": "Numer faktury",
        "Description": "Opis",
        "Save": "Zapisz",
        "New": "Nowa",
        "Supplier orders": "Dostawy",
        "New supplier": "Nowy dostawca",
        "Contact person": "Osba kontaktowa",
        "Add product": "Dodaj produkt",
        "Remove": "Usuń",
        "Product": "Produkt",
        "Unit": "Jednostka",
        "Quantity": "Ilość",
        "Price net": "Cena netto",
        "Price gross": "Cena brutto",
        "Vat rate": "VAT",
        "Delivery history": "Historia dostaw",
        "Add delivery": "Dodaj dostawę",
        "Suppliers": "Dostawcy",
        "Manufacturers": "Producenci",
        "Document date": "Data dokumentu",
        "Quantity of positions": "Ilość pozycji",
        "Created at": "Data dodania"
    }
};
